import { Component, OnInit } from '@angular/core';
import { ContentElement, VisibilityEnum } from '@urbannex/storethemes';
import { SectionEditorStoreService } from '../section-editor-dialog/section-editor-store.service';

@Component({
  selector: 'kve-visibility-popover',
  templateUrl: './visibility-popover.component.html',
  styleUrls: ['./visibility-popover.component.scss']
})
export class VisibilityPopoverComponent implements OnInit{
  
  title:string = 'Visibility Options';
  content:ContentElement;
  service:string;
  
  visibilityOptions = [
    { label: 'Visible on all devices', value: 'visible' },
    { label: 'Hidden on mobile', value: 'hidden-on-mobile' },
    { label: 'Hidden on desktop', value: 'hidden-on-desktop' },
    { label: 'Hidden on tablet', value: 'hidden-on-tablet' }
  ];
  VisibilityEnum = VisibilityEnum;
  selectedVisibility:VisibilityEnum; // = this.visibilityOptions[0].value;

  constructor(private sectionEditorStore:SectionEditorStoreService) {

  }

  ngOnInit(): void {
    console.log(this.content)
    this.selectedVisibility = this.content?.visibility != undefined ? this.content.visibility : VisibilityEnum.VISIBLE;
    if(!this.service){
      this.service = "sectionStore"
    }
  }

  onVisibilityChange(visibility: VisibilityEnum) {
    //this.selectedVisibility = newVisibility;
    // Emit the change or handle it as needed
   
    //const visibility = VisibilityEnum[newVisibility];
    console.log(visibility)
    if(this.service == "sectionStore" || this.service == "sectionBuilder" || this.service == "section"){
      if(this.content.isHeader || this.content.name == "Title"){
        this.sectionEditorStore.updateTitle({...this.content, visibility});
      }
      this 
    }else{

    }
  }

}
